// Selo compacto para marcar requisitos CORE (alta prioridade/segurança) — usar inline ao lado
// do código do requisito, nunca como pill grande separada.
export default function CoreBadge({ size = 16 }) {
  return (
    <span
      className="ms"
      title="Requisito CORE — alta prioridade/segurança"
      style={{
        fontSize: size,
        color: 'var(--am-link)',
        verticalAlign: 'middle',
        lineHeight: 1,
        display: 'inline-flex',
      }}
    >
      verified
    </span>
  );
}
